






















import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo, PathController, VFS } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'

@Component({})
export default class DUDCategories extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() xattr!: string[]
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>

  private category: string[] = []
  private filterdDocuments: FileInfo[] = []

  async mounted () {
    const scroll = this.$refs.scroller as HTMLElement
    if (scroll) {
      scroll.scrollTop = this.pageConfig.scrollPosition
      scroll.addEventListener('scroll', this.handleScroll)
    }
  }

  filterDocuments (categoryName: string) {
    this.filterdDocuments = this.files.filter((val: FileInfo) => val?.XAttr?.Category === categoryName)
  }

  handleScroll (event: any) {
    this.$emit('on-scroll', event.target.scrollTop)
  }
}

